import React from "react";
const defaultLayout = ({ children }) => {
  return (
    <>
      {children}
    </>
  );
};

export default defaultLayout;
